import { Trans } from "@lingui/react/macro";
import { createFileRoute } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import { ApiKeysClient } from "@/components/account/api-keys-client";

export const Route = createFileRoute("/_authenticated/account/provider/api-keys")({
  component: ProviderApiKeysPage,
});

function ProviderApiKeysPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-foreground text-2xl font-semibold tracking-[-0.02em]">
          <Trans>API keys</Trans>
        </h1>
        <p className="text-muted-foreground mt-1 text-sm">
          <Trans>Programmatic access to your appointments + booking widget embed.</Trans>
        </p>
      </header>
      <ApiKeysClient />
      <AccountSecurityBanner />
    </div>
  );
}
